import { requestKarangoApi } from "../../../core/api/karangoTransport";

export async function blockRemoteUser(targetId) {
  if (!targetId) {
    throw new Error("targetId requis.");
  }

  return requestKarangoApi("/v1/blocks", {
    method: "POST",
    requiresAuth: true,
    body: { targetId },
  });
}

export async function listRemoteBlocks({ signal } = {}) {
  const payload = await requestKarangoApi("/v1/blocks", {
    requiresAuth: true,
    signal,
  });
  return Array.isArray(payload?.blocks) ? payload.blocks : [];
}

export async function unblockRemoteUser(targetId) {
  if (!targetId) throw new Error("targetId requis.");
  return requestKarangoApi(`/v1/blocks/${encodeURIComponent(String(targetId))}`, {
    method: "DELETE",
    requiresAuth: true,
  });
}
